<script setup lang="ts">
  import { computed } from 'vue';

  interface Props {
    variant?: 'default' | 'primary' | 'outline';
    count?: number;
  }

  const emits = defineEmits(['buttonClick']);
  withDefaults(defineProps<Props>(), {
    variant: 'default',
    flex: 1,
    count: undefined,
  });

  const style = computed(() => {
    return {};
  });

  const handleClick = () => {
    emits('buttonClick');
  };
</script>

<template>
  <button type="button" :class="variant" :style="style" @click="handleClick">
    <slot name="icon" />
    <span class="text"><slot /></span>
    <span v-if="count !== undefined" class="count">{{ count }}</span>
  </button>
</template>

<style lang="scss" scoped>
  @use '@/assets/scss/variables' as vars;

  button {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.3906vw;
    height: 5vw;
    padding: 0 1.1719vw;
    border-radius: 0.625vw;
    background: #fff;
    border: 0.0781vw solid #d9d9d9b3;
    box-shadow: 0px 0.1563vw 0.3125vw #8888883d;
    font-size: 1.7969vw;

    .text {
      color: #000;
    }
    .count {
      padding-left: 0.7813vw;
      color: #000;
    }

    &.primary {
      background: var(--brand-primary);
      border: none;
      .text,
      .count {
        color: #fff;
      }
    }

    &.outline {
      background: #fff;
      border: 0.0781vw solid var(--brand-primary);
      .text,
      .count {
        color: var(--brand-primary);
      }
    }
  }
</style>
